import {FC, MouseEvent, useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Loading} from '../../../components/Loading/Loading'
import {GET, POST, POST_ADM, PUT} from '../../../services/api'
import {i18n} from '../../../translate/i18n'
import Swal from 'sweetalert2'
import {ModalWrapper} from '../../../components/Modals/General/ModalWrapper/ModalWrapper'
import useModals from '../../../hooks/useModals'
import {convertBrazilToUTC, secondsToHour, telephoneNoMask} from '../../../utils/formater'
import {Button} from '../../../components/Button/Button'
import {BreadCrumbs} from '../../../components/BreadCrumbs/breadCrumbrs'
import {QueueCard} from '../../../components/QueueCard/QueueCard'
import {Input} from '../../../components/Input/Input'
import {exportExcel} from '../../../utils/utils'

type QueueType = {
  id: string
  position: number
  minutesOnQueue: string
  people: number
  name: string
  phone: string
  seconds: number
  createdAt: Date
  preferential: boolean
  finalized: 'confirmed' | 'removed' | null
  entryTime: string | null
  updatedAt: string | null
}

type QueueConfig = {
  id: string
  able: boolean
  limitTime: number
  limitPeople: number
  limitPeopleGroup: number
  pluginspaceId: number
  createdAt: string
  updatedAt: string
  observation: string
  useTerms: boolean
}

const QueueContent: FC = () => {
  const navigate = useNavigate()
  const {showWrapperModal, closeWrapperModal} = useModals()
  const [loading, setLoading] = useState(false)
  const [loadingNewData, setLoadingNewData] = useState(false)
  const [queues, setQueues] = useState<QueueType[]>([])
  const [queueSelected, setQueueSelected] = useState<QueueType | null>(null)
  const [limitMinutes, setLimitMinutes] = useState(0)
  const [option, setOption] = useState<'removed' | 'confirmed' | 'add' | 'edit' | 'export_csv'>(
    'removed'
  )
  const [queueConfigId, setQueueConfigId] = useState()
  const [statusFilter, setStatusFilter] = useState<'all' | 'confirmed' | 'removed' | 'queue'>(
    'queue'
  )
  const [preferentialFilter, setPreferentialFilter] = useState<'all' | 'y' | 'n'>('all')
  const [timeFilter, setTimeFilter] = useState<'all' | '12' | '24'>('all')
  const [totalPeopleQueue, setTotalPeopleQueue] = useState(0)

  /* Variavel para função do CSV */
  const [startDate, setStartDate] = useState('')
  const [startHour, setStartHour] = useState('')
  const [finishDate, setFinishDate] = useState('')
  const [finishHour, setFinishHour] = useState('')

  const [queueConfig, setQueueConfig] = useState<QueueConfig>()

  //variavel utilizada para adicionar cliente a fila
  const [customerName, setCustomerName] = useState<string>('')
  const [customerPhone, setCustomerPhone] = useState<string>('')
  const [peopleNumber, setPeopleNumber] = useState<number>(0)
  const [preferentialQueue, setPreferentialQueue] = useState<boolean>(false)

  const calcTimeSubstractHour = (hour: number) => {
    const newDate = new Date(new Date().getTime() - hour * 3600 * 1000)
    return newDate.toISOString()
  }

  const getQueues = async () => {
    try {
      const res = await GET('/queueReservation/queueConfig')
      if (res.success && res.data && res.data[0] && res.data[0].id && res.data[0].limitTime) {
        const queueConfigId = res.data[0].id
        setQueueConfig(res.data[0])
        setLimitMinutes(res.data[0].limitTime)
        if (queueConfigId) {
          setQueueConfigId(res.data[0].id)
          const queuesRes = await GET(
            `/queueReservation/queue/${queueConfigId}?status=${statusFilter}&preferential=${preferentialFilter}&timeInitial=${
              timeFilter !== 'all' ? calcTimeSubstractHour(parseInt(timeFilter)) : timeFilter
            }`
          )
          if (queuesRes && queuesRes.data && queuesRes.data.length > 0) {
            let totalPeopleQueueAux = 0
            const queuesData = queuesRes.data.map((queue: QueueType) => {
              const seconds =
                parseInt(queue.minutesOnQueue.split(':')[0]) * 3600 +
                parseInt(queue.minutesOnQueue.split(':')[1]) * 60 +
                parseInt(queue.minutesOnQueue.split(':')[2])
              queue.seconds = seconds
              totalPeopleQueueAux += queue.people
              return queue
            })
            setQueues(queuesData)
            setTotalPeopleQueue(totalPeopleQueueAux)
          } else {
            setQueues([])
          }
        } else {
          Swal.fire({
            customClass: {
              container: 'my-swal',
            },
            icon: 'error',
            title: 'Erro!',
            text: 'Não foi possível encontrar configuração de fila',
          }).then(() => navigate('/queue/config'))
        }
      } else {
        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'error',
          title: 'Erro!',
          text: 'É necessário configurar a fila antes de receber os dados',
        }).then(() => navigate('/queue/config'))
      }
    } catch (e) {
      console.log(e)
      Swal.fire({
        customClass: {
          container: 'my-swal',
        },
        icon: 'error',
        title: 'Erro!',
        text: e && typeof e === 'string' ? e : 'Erro ao carregar fila de espera',
      })
    }
  }

  const changeQueue = async () => {
    if (queueSelected) {
      const queue = Object.assign(queueSelected)
      const opt = option.toString()
      setQueueSelected(null)
      setOption('confirmed')
      try {
        setLoading(true)
        const res = await PUT(`/queueReservation/queue/${queue.id}`, {
          entryTime: new Date(),
          finalized: opt,
        })
        await getQueues()
        setLoading(false)
        if (res && res.success) {
          Swal.fire({
            customClass: {
              container: 'my-swal',
            },
            icon: 'success',
            title: 'Fila alterada!',
            text:
              opt === 'removed' ? 'Removido da fila com sucesso' : 'Chegada confirmada com sucesso',
          })
        } else {
          Swal.fire({
            customClass: {
              container: 'my-swal',
            },
            icon: 'error',
            title: 'Erro!',
            text: 'Falha ao alterar fila',
          })
        }
      } catch (e) {
        setLoading(false)
        console.log(e)
        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'error',
          title: 'Erro!',
          text: 'Falha ao alterar fila',
        })
      }
    } else {
      Swal.fire({
        customClass: {
          container: 'my-swal',
        },
        icon: 'error',
        title: 'Erro!',
        text: 'Falha ao alterar fila',
      })
    }
  }

  const updateAll = async (finalized: string) => {
    try {
      Swal.fire({
        customClass: {
          container: 'my-swal',
        },
        icon: 'warning',
        title:
          finalized === 'removed'
            ? 'Você tem certeza que deseja remover todas as pessoas da fila?'
            : 'Você tem certeza que deseja confirmar todas as pessoas da fila?',
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: false,
        cancelButtonColor: '#dc3741',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
      }).then(async (result) => {
        if (result.isConfirmed) {
          setLoading(true)
          const res = await POST(`/queueReservation/queue/update-all`, {
            ids: queues.filter((queue) => !queue.finalized).map((queue) => queue.id),
            finalized,
          })
          setLoading(false)
          if (res && res.success) {
            Swal.fire({
              customClass: {
                container: 'my-swal',
              },
              icon: 'success',
              title: 'Filas alteradas!',
              text:
                finalized === 'removed'
                  ? 'Filas removidas com sucesso'
                  : 'Filas confirmadas com sucesso',
            }).then(() => setQueues([]))
          } else {
            Swal.fire({
              customClass: {
                container: 'my-swal',
              },
              icon: 'error',
              title: 'Erro!',
              text: 'Falha ao alterar filas',
            }).then(async () => window.location.reload())
          }
        }
      })
    } catch (e) {
      setLoading(false)
      console.log(e)
      Swal.fire({
        customClass: {
          container: 'my-swal',
        },
        icon: 'error',
        title: 'Erro!',
        text: 'Falha ao alterar filas',
      }).then(async () => window.location.reload())
    }
  }

  const init = async () => {
    setLoading(true)
    await getQueues()
    setLoading(false)
  }

  async function getQueue() {
    try {
      const elementLoading = document.getElementById('loading-all')
      if (queueConfigId && !elementLoading) {
        let newStatusFilter = statusFilter.toString()
        let newPreferentialFilter = preferentialFilter.toString()
        let newTimeFilter = timeFilter.toString()
        const elementStatus: any = document.getElementById('status-filter-input')
        const elementPreferential: any = document.getElementById('preferential-filter-input')
        const elementTime: any = document.getElementById('time-filter-input')
        if (elementStatus && elementStatus.value) newStatusFilter = elementStatus.value
        if (elementPreferential && elementPreferential.value)
          newPreferentialFilter = elementPreferential.value
        if (elementTime && elementTime.value) newTimeFilter = elementTime.value

        const queuesRes = await GET(
          `/queueReservation/queue/${queueConfigId}?status=${newStatusFilter}&preferential=${newPreferentialFilter}&timeInitial=${
            newTimeFilter !== 'all' ? calcTimeSubstractHour(parseInt(newTimeFilter)) : newTimeFilter
          }`
        )
        if (queuesRes && queuesRes.data && queuesRes.data.length > 0) {
          const queuesData = queuesRes.data.map((queue: QueueType) => {
            const seconds =
              parseInt(queue.minutesOnQueue.split(':')[0]) * 3600 +
              parseInt(queue.minutesOnQueue.split(':')[1]) * 60 +
              parseInt(queue.minutesOnQueue.split(':')[2])
            queue.seconds = seconds
            return queue
          })
          const newQueuesData = [...queues]
          setLoadingNewData(true)
          queuesData.map((q: any) => {
            const find = queues.find((qq) => qq.id === q.id)
            if (!find) {
              newQueuesData.push(q)
            }
          })
          setLoadingNewData(false)
          setQueues(newQueuesData)
        } else {
          setQueues([])
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  async function initGetQueue() {
    // Simulando uma chamada assíncrona
    await getQueue()

    setTimeout(initGetQueue, 30000)
  }

  async function addCustomerQueue() {
    try {
      if (peopleNumber <= 0) {
        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'warning',
          title: 'Atenção!',
          text: `Precisa haver uma pessoa ou mais para entrar na fila.`,
        })
        return
      }

      if (queueConfig && parseInt(peopleNumber.toString()) > queueConfig.limitPeopleGroup) {
        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'warning',
          title: 'Atenção!',
          html: `Há mais pessoas do que o permitido na fila de espera (Máximo ${queueConfig.limitPeopleGroup})`,
        })
        return
      }

      if (!customerName) {
        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'warning',
          title: 'Atenção!',
          text: `É necessário adicionar um nome para entrar na fila.`,
        })
        return
      }

      if (!customerName.split(' ')[1]) {
        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'warning',
          title: 'Atenção!',
          text: `É necessário adicionar um sobrenome para entrar na fila.`,
        })
        return
      }

      if (!customerPhone || customerPhone.includes('_')) {
        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'warning',
          title: 'Atenção!',
          text: `Celular inválido.`,
        })
        return
      }
      setLoading(true)
      const queueResponse = await POST('/queueReservation/queue', {
        people: parseInt(peopleNumber.toString()),
        name: customerName,
        phone: telephoneNoMask(customerPhone),
        preferential: preferentialQueue,
        subscription: null,
      })
      await getQueues()
      setLoading(false)

      if (!queueResponse || !queueResponse.success) {
        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'error',
          title: 'Erro ao cadastrar cliente na fila!',
          text: 'Não foi possível cadastrar cliente na fila.',
        })
      } else {
        setCustomerName('')
        setCustomerPhone('')
        setPeopleNumber(0)
        setPreferentialQueue(false)

        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'success',
          title: 'Sucesso!',
          text: 'Cadastrar do cliente na fila.',
        }).then(() => closeWrapperModal())
      }
    } catch (err: any) {
      let title = 'Erro ao entrar na fila!'
      let text = 'Não foi possível entrar na fila.'
      if (err && err.response && err.response.data && err.response.data.error) {
        title = err.response.data.error
      }
      if (err && err.response && err.response.data && err.response.data.message) {
        text = err.response.data.message
      }

      if (err && typeof err === 'string') {
        text = err.toString()
      }

      setLoading(false)
      Swal.fire({
        customClass: {
          container: 'my-swal',
        },
        icon: 'error',
        title,
        text,
      })
    }
  }

  async function exportCSV() {
    try {
      if (!startDate || !startHour || !finishDate || !finishHour) {
        Swal.fire({
          icon: 'warning',
          text: 'Preencha todos os campos',
          title: 'Falta campos',
        })
        return
      }

      setLoading(true)

      const dataInit = convertBrazilToUTC(`${startDate}T${startHour}`)
      const dataFin = convertBrazilToUTC(`${finishDate}T${finishHour}`)
      const queueResponse = await POST('/queueReservation/queue/filter_csv', {
        dataInit: dataInit,
        dataFin: dataFin,
      })
      setLoading(false)

      if (!queueResponse || !queueResponse.success) {
        Swal.fire({
          icon: 'error',
          text: 'Erro ao exportar CSV',
          title: 'Erro ao exportar CSV',
        })

        return
      }

      queueResponse.data.forEach((item: any) => {
        const parseDate = (dateString: string) => {
          const [datePart, timePart] = dateString.split(', ')
          const [day, month, year] = datePart.split('/')
          return new Date(`${year}-${month}-${day}T${timePart}`)
        }

        const horaChegada = parseDate(item['Hora de Chegada'])

        if (item['Hora de Entrada']) {
          const horaEntrada = parseDate(item['Hora de Entrada'])

          const difMs = horaEntrada.getTime() - horaChegada.getTime()

          const difSeg = Math.floor(difMs / 1000)

          // Calculando horas, minutos e segundos
          const hours = Math.floor(difSeg / 3600)
          const minutes = Math.floor((difSeg % 3600) / 60)
          const seconds = difSeg % 60

          // Formatando para Hora:Min:Seg
          const tempoEspera = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
            2,
            '0'
          )}:${String(seconds).padStart(2, '0')}`

          item['Tempo de Espera'] = tempoEspera
        } else {
          item['Tempo de Espera'] = ''
        }
      })

      exportExcel(queueResponse.data, 'fila-espera')

      setFinishDate('')
      setFinishHour('')
      setStartDate('')
      setStartHour('')
    } catch (error) {
      setLoading(false)
      Swal.fire({
        icon: 'error',
        text: 'Erro ao exportar CSV',
        title: 'Erro ao exportar CSV',
      })
    }
  }

  async function editCustomerQueue() {
    try {
      if (!queueSelected || parseInt(queueSelected.id) <= 0) {
        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'warning',
          title: 'Atenção!',
          text: `Reserva não encontrada.`,
        })
        return
      }

      if (peopleNumber <= 0) {
        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'warning',
          title: 'Atenção!',
          text: `Precisa haver uma pessoa ou mais para entrar na fila.`,
        })
        return
      }
      setLoading(true)
      const queueResponse = await PUT(`/queueReservation/queue/${queueSelected.id}`, {
        people: parseInt(peopleNumber.toString()),
      })
      setLoading(false)

      if (!queueResponse || !queueResponse.success) {
        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'error',
          title: 'Erro ao cadastrar cliente na fila!',
          text: 'Não foi possível cadastrar cliente na fila.',
        })
      } else {
        setQueueSelected(null)
        setCustomerName('')
        setCustomerPhone('')
        setPeopleNumber(0)
        setPreferentialQueue(false)

        const newQueue = queues.map((queue) => {
          if (queue.id === queueSelected.id) {
            queue.people = peopleNumber
          }

          return queue
        })

        setQueues(newQueue)

        Swal.fire({
          customClass: {
            container: 'my-swal',
          },
          icon: 'success',
          title: 'Sucesso!',
          text: 'Cliente na fila editado com sucesso.',
        }).then(() => closeWrapperModal())
      }
    } catch (err: any) {
      let title = 'Erro ao editar fila!'
      let text = 'Não foi possível editar  fila.'
      if (err && err.response && err.response.data && err.response.data.error) {
        title = err.response.data.error
      }
      if (err && err.response && err.response.data && err.response.data.message) {
        text = err.response.data.message
      }

      if (err && typeof err === 'string') {
        text = err.toString()
      }

      setLoading(false)
      Swal.fire({
        customClass: {
          container: 'my-swal',
        },
        icon: 'error',
        title,
        text,
      })
    }
  }

  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    if (queueConfigId) {
      initGetQueue()
    }
  }, [queueConfigId])

  useEffect(() => {
    if (queueSelected) {
      setPeopleNumber(queueSelected.people)
    }
  }, [queueSelected])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>{i18n.t(`queue.menage`)} </span>
                <BreadCrumbs />
              </h3>
              <Button
                text={i18n.t(`queue.add`)}
                color='primary'
                iconColor='#FFF'
                icon='fas fa-filter'
                size='small'
                horizontalPadding={6}
                btnAttr={{
                  type: 'button',
                }}
                click={() => {
                  setOption('add')
                  showWrapperModal(i18n.t(`queue.add`))
                }}
                btnClass='fw-bolder m-3'
              />
            </div>

            <div className='card-body d-flex flex-column gap-5'>
              <div className='d-flex align-items-center justify-content-start'>
                <div className='d-flex w-75 '>
                  <div className=' align-items-end  justify-content-start me-5 flex-grow-1'>
                    <span className='align-self-start'>Status</span>
                    <Input
                      inputAttr={{
                        type: 'select',
                      }}
                      idInput='status-filter-input'
                      options={[
                        {
                          value: 'all',
                          select: i18n.t('queue.all'),
                        },
                        {
                          value: 'queue',
                          select: i18n.t('queue.in_queue'),
                        },
                        {
                          value: 'confirmed',
                          select: i18n.t('queue.confirmed'),
                        },
                        {
                          value: 'removed',
                          select: i18n.t('queue.removed'),
                        },
                      ]}
                      placeholder={'Status'}
                      value={statusFilter}
                      change={(value: any) => setStatusFilter(value)}
                    />
                  </div>

                  <div className=' flex-grow-1 align-items-center me-5 justify-content-between'>
                    <span className='align-self-start'>{i18n.t('queue.preferential')}</span>
                    <Input
                      inputAttr={{
                        type: 'select',
                      }}
                      idInput='preferential-filter-input'
                      options={[
                        {
                          value: 'all',
                          select: i18n.t('queue.all'),
                        },
                        {
                          value: 'y',
                          select: i18n.t('queue.yes'),
                        },
                        {
                          value: 'n',
                          select: i18n.t('queue.no'),
                        },
                      ]}
                      placeholder={i18n.t('queue.preferential')}
                      value={preferentialFilter}
                      change={(value: any) => setPreferentialFilter(value)}
                    />
                  </div>

                  <div className=' flex-grow-1 align-items-center me-5 justify-content-between'>
                    <span className='align-self-start'>{i18n.t('queue.show')}</span>
                    <Input
                      inputAttr={{
                        type: 'select',
                      }}
                      idInput='time-filter-input'
                      options={[
                        {
                          value: 'all',
                          select: i18n.t('queue.all'),
                        },
                        {
                          value: '12',
                          select: i18n.t('queue.show_text').replace('@', '12'),
                        },
                        {
                          value: '24',
                          select: i18n.t('queue.show_text').replace('@', '24'),
                        },
                      ]}
                      placeholder={i18n.t('queue.preferential')}
                      value={timeFilter}
                      change={(value: any) => setTimeFilter(value)}
                    />
                  </div>
                  <div className='h-100 d-flex  align-self-end gap-4'>
                    <Button
                      text='Filtrar'
                      color='primary'
                      iconColor='#FFF'
                      icon='fas fa-filter'
                      size='small'
                      horizontalPadding={6}
                      btnAttr={{
                        type: 'button',
                      }}
                      click={async () => {
                        setLoading(true)
                        await getQueues()
                        setLoading(false)
                      }}
                      btnClass='mb-0 fw-bolder'
                    />
                    <Button
                      text='Exportar CSV'
                      color='success'
                      iconColor='#FFF'
                      icon='fa fa-download'
                      size='small'
                      horizontalPadding={6}
                      btnAttr={{
                        type: 'button',
                      }}
                      click={async () => {
                        setOption('export_csv')
                        showWrapperModal('Exportar Dados CSV')
                      }}
                      btnClass='mb-0 fw-bolder'
                    />
                  </div>
                </div>
              </div>
              <div className='d-flex flex-row w-full gap-5'>
                <Button
                  text={i18n.t(`queue.confirm_all`)}
                  color='primary'
                  iconColor='#FFF'
                  size='small'
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => updateAll('confirmed')}
                  btnClass='fw-bolder'
                />
                <Button
                  text={i18n.t(`queue.cancel_all`)}
                  color='primary'
                  iconColor='#FFF'
                  size='small'
                  btnAttr={{
                    type: 'button',
                  }}
                  click={() => updateAll('removed')}
                  btnClass='fw-bolder'
                />
              </div>
              {queues.length > 0 ? (
                queues.map((queue) => (
                  <QueueCard
                    queue={queue}
                    setQueueSelected={setQueueSelected}
                    setOption={setOption}
                    showWrapperModal={showWrapperModal}
                    limitMinutes={limitMinutes}
                  />
                ))
              ) : (
                <div className='d-flex flex-column w-100 gap-2 align-items-center'>
                  <h2 style={{color: '#2A2D36', fontWeight: '400'}}>{i18n.t(`queue.empty`)} :(</h2>
                </div>
              )}
            </div>
          </div>
          <ModalWrapper
            zIndex={1000}
            confirmAction={() =>
              option === 'add'
                ? addCustomerQueue()
                : option === 'edit'
                ? editCustomerQueue()
                : option === 'export_csv'
                ? exportCSV()
                : changeQueue()
            }
            shouldCloseModal={option === 'add' || option === 'edit' ? false : true}
            textAction={
              option === 'add'
                ? i18n.t(`queue.add`)
                : option === 'edit'
                ? i18n.t(`queue.edit`)
                : option === 'removed'
                ? i18n.t(`queue.cancel_button`)
                : option === 'export_csv'
                ? 'Exportar CSV'
                : i18n.t(`queue.confirm_button`)
            }
          >
            {option === 'add' ? (
              <>
                <Input
                  inputAttr={{
                    type: 'defautl',
                  }}
                  placeholder='Nome do Cliente'
                  label={'Nome do Cliente'}
                  value={customerName}
                  change={(value: string) => {
                    // Verifica se contém apenas letras, espaços e acentos
                    const isValidName = /^[a-zA-ZÀ-ÿ\s]*$/.test(value)

                    // Só permite a alteração se for válido
                    if (isValidName) {
                      setCustomerName(value)
                    }
                  }}
                />
                <Input
                  inputAttr={{
                    type: 'tel',
                  }}
                  label={'Telefone do cliente'}
                  minNumber={0}
                  value={customerPhone}
                  change={(value: string) => {
                    setCustomerPhone(value)
                  }}
                />
                <Input
                  inputAttr={{
                    type: 'checkbox',
                  }}
                  placeholder='0'
                  label={'Fila Preferencial'}
                  value={preferentialQueue}
                  checked={preferentialQueue}
                  change={(value: boolean) => {
                    setPreferentialQueue(value)
                  }}
                />
                <Input
                  inputAttr={{
                    type: 'number',
                  }}
                  label={'Número de Pessoas na Fila'}
                  value={peopleNumber}
                  change={(value: number) => {
                    value >= 0 && setPeopleNumber(value)
                  }}
                />
              </>
            ) : (
              <>
                {option === 'edit' ? (
                  <Input
                    inputAttr={{
                      type: 'number',
                    }}
                    placeholder='0'
                    label={'Número de Pessoas na Fila'}
                    minNumber={0}
                    value={peopleNumber ? peopleNumber : ''}
                    change={(value: number) => {
                      setPeopleNumber(value)
                    }}
                    maxNumber={queueConfig?.limitPeople ? queueConfig?.limitPeople : 0}
                  />
                ) : (
                  <>
                    {option === 'export_csv' ? (
                      <>
                        <div className='d-flex gap-4'>
                          <Input
                            inputAttr={{
                              type: 'date',
                            }}
                            placeholder='Data de Inicio'
                            label={'Data de Inicio'}
                            value={startDate}
                            change={(value: string) => {
                              setStartDate(value)
                            }}
                          />
                          <Input
                            inputAttr={{
                              type: 'time',
                            }}
                            placeholder='Hora de Inicio'
                            label={'Hora de Inicio'}
                            value={startHour}
                            change={(value: string) => {
                              setStartHour(value)
                            }}
                          />
                        </div>
                        <div className='d-flex gap-4'>
                          <Input
                            inputAttr={{
                              type: 'date',
                            }}
                            placeholder='Data Final'
                            label={'Data Final'}
                            value={finishDate}
                            change={(value: string) => {
                              setFinishDate(value)
                            }}
                          />
                          <Input
                            inputAttr={{
                              type: 'time',
                            }}
                            placeholder='Hora Final'
                            label={'Hora Final'}
                            value={finishHour}
                            change={(value: string) => {
                              setFinishHour(value)
                            }}
                          />
                        </div>
                      </>
                    ) : (
                      <>
                        <p className='my-6' style={{margin: 0, fontWeight: 400, fontSize: 14}}>
                          {option === 'removed'
                            ? i18n.t(`queue.cancel_text`)
                            : i18n.t(`queue.confirm_text`)}
                        </p>
                        {queueSelected && (
                          <div
                            className='d-flex flex-row px-4 py-6 align-items-center'
                            style={{
                              border: '1px solid #D3D9E8',
                              borderLeft: '4px solid #D3D9E8',
                              borderRadius: 4,
                            }}
                          >
                            <div className='d-flex flex-column gap-2'>
                              <p style={{color: '#6E7586', margin: 0}}>
                                <b style={{color: '#2A2D36'}}>{queueSelected.name}</b>
                              </p>
                              <p style={{color: '#6E7586', margin: 0}}>
                                <b style={{color: '#2A2D36'}}>
                                  {queueSelected.people} {i18n.t(`queue.people`)}
                                </b>
                              </p>
                              <p style={{color: '#6E7586', margin: 0}}>{queueSelected.phone}</p>
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </ModalWrapper>
        </div>
      )}
    </>
  )
}

const Queue: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: i18n.t(`queue.menage`), path: 'queue', isActive: true},
        ]}
      >
        {i18n.t(`queue.menage`)}
      </PageTitle>
      <QueueContent />
    </>
  )
}

export {Queue}
